export default angular
  .module('app.services.verification-message', [])
  .service('VerificationMessage', function () {
    let verificationMsgs = {
      'forward-mail': {
        verification:
          "You've been verified! We'll file your USPS mail forwarding form. It " +
          'will take up to 12 days for your mail to start arriving.  If your move date is ' +
          "further in the future, we'll submit your form 12 days before your move.",
        already_verified:
          "You're all set - we'll file your USPS mail forwarding form. " +
          'It will take up to 12 days for your mail to start arriving.  If your move date is ' +
          "further in the future, we'll submit your form 12 days before your move.",
      },
      'update-accounts': {
        verification:
          "You've been verified and we're now submitting your updates to each " +
          'organization. Some updates may take longer than others, but you can always check ' +
          'the status here.',
      },
      default:
        "You've verified you are who you say you are and now you can continue with your moving tasks.",
    };
    return {
      init(key, state) {
        if (key != null) {
          if (
            (verificationMsgs[state] != null
              ? verificationMsgs[state][key]
              : undefined) != null
          ) {
            return verificationMsgs[state][key];
          } else {
            return verificationMsgs.default;
          }
        }
      },
    };
  });
